import React, { useEffect, useState } from 'react';
import { t, Plural } from '@lingui/macro';
import { useSelector } from 'react-redux';
import _ from 'lodash';

import Button from '@mui/material/Button';

import { INSTITUTION } from 'common/dattrs';
import EmptyInstitutionList from 'components/institution/EmptyInstitutionList';
import InstitutionCreateDialog from 'components/institution/InstitutionCreateDialog';
import InstitutionList from 'components/institution/InstitutionList';
import InstitutionService from 'service/institution';
import Loader from 'components/common/loader/Loader';
import { getInstitutions } from 'redux/institution/institution.selectors';

import Page from './Page';
import styles from './Institutions.module.scss';

function Institutions(props) {
  const institutions = useSelector(getInstitutions);
  const [createDialogVisible, setCreateDialogVisible] = useState(false);
  const [loadingInstitutions, setLoadingInstitutions] = useState(true);

  function institutionListEmpty() {
    return !loadingInstitutions && _.isEmpty(institutions);
  }

  function getContent() {
    if (loadingInstitutions) {
      return null;
    }

    if (institutionListEmpty()) {
      return (
        <EmptyInstitutionList
          onCreate={() => {
            setCreateDialogVisible(true);
          }}
        />
      );
    }

    return <InstitutionList />;
  }

  function getPageActions() {
    if (loadingInstitutions || _.isEmpty(institutions)) {
      return null;
    }

    return (
      <div className={styles.pageActions}>
        <Button
          {...INSTITUTION.create}
          variant='contained'
          onClick={() => {
            setCreateDialogVisible(true);
          }}
        >{t`Create Institution`}</Button>
      </div>
    );
  }

  useEffect(() => {
    async function fetchData() {
      await InstitutionService.fetchInstitutions();
      setLoadingInstitutions(false);
    }

    fetchData();
  }, []);

  function getPageDescription() {
    if (_.isEmpty(institutions)) {
      return null;
    }

    const institutionCount = institutions.length;
    return (
      <div>
        <span {...INSTITUTION.count} className={styles.courseCount}>
          {institutionCount}
        </span>
        <span>
          <Plural value={institutionCount} one='institution' other='institutions'></Plural>
        </span>
      </div>
    );
  }

  function getBreadcrumbs() {
    return [];
  }

  return (
    <Page title={t`Institutions`} breadcrumbs={getBreadcrumbs()} description={getPageDescription()} actions={getPageActions()}>
      <Loader visible={loadingInstitutions} />
      {getContent()}
      {createDialogVisible && <InstitutionCreateDialog onHide={() => setCreateDialogVisible(false)} />}
    </Page>
  );
}

export default Institutions;
